export const StructureEditableDataArray = (UiValue) => {
  if (UiValue.Value.length > 0 && UiValue?.IdCommand?.length > 0) {
    const values = UiValue?.Value?.split(",");
    const idCommands = UiValue?.IdCommand?.split(",").map((idcmd) =>
      Number(idcmd)
    );
    const DefaultValues = values.map((value, index) => ({
      ItemContent: values[index],
      ItemValue: idCommands[index],
    }));
    return DefaultValues;
  }
};
